import React, { useState, useEffect, useContext } from "react";
import styles from "./Market.module.sass";
import Icon from "../../../../components/Icon";
import Row from "./Row";
import { getProducts } from "../../../../Firebase/firebaseDatabase";
import {
  collection,
  getDocs,
} from "@firebase/firestore";
import { db } from './../../../../Firebase/firebaseConfig';
import { GlobalState } from "../../../../App";
import LoadingIndicator from "../../../../LoadingScreen/LoadingIndicator";
import { getIsoForSort, toIsoString } from "../../../../utils/extensions";

const Market = ({ searchBy, filterBy }) => {

  const [loading, setLoading] = useState(true);

  const [selectedFilters, setSelectedFilters] = useState([]);
  const { categories } = useContext(GlobalState);

  const handleChange = (id) => {
    if (selectedFilters.includes(id)) {
      setSelectedFilters(selectedFilters.filter((x) => x !== id));
    } else {
      setSelectedFilters((selectedFilters) => [...selectedFilters, id]);
    }
  };

  const [products, setProducts] = useState([])

  const fetchProducts = async () => {
    await getProducts().then(async (data) => {

      data.forEach(async (element, index) => {

        categories.forEach((category, i) => {
          if (category.id === element?.data?.category) {
            element.data.category = category?.data?.titleEn
          }
        })
        await getDocs(
          collection(db, "product", element?.id, "variation")
        )
          .then(async (doc) => {
            const variationDetails = doc.docs.map((doc) => ({
              data: doc.data(),
              id: doc.id,
            }));
            if (variationDetails.length === 0) {
              setProducts((oldData) => [...oldData, element])
            }
            else {
              variationDetails.forEach(async (variationData, i) => {

                // add poduct data in variation data of that product
                variationData.product = element;

                variationData.data.images = variationData.data.images[0]
                setProducts((oldData) => [...oldData, variationData])
              })
            }
            // setLoading(false)
          })
          .catch((e) => {
            // console.log("ORDER ERROR VARIATION", e);
            // setLoading(false);
          });
      });

    }
    )
  }

  useEffect(() => {
    fetchProducts()
  }, []);

  const [isPrevActive, setIsPrevActive] = useState(false)
  const [isNextActive, setIsNextActive] = useState(true)
  const [activePageNum, setActivePageNum] = useState(1)
  const [pageCount, setPageCount] = useState(1)

  const page_items_count = 50;
  const [range, setRange] = useState({
    start: 0,
    end: page_items_count
  })

  const [itemsList, setItemsList] = useState([])
  const [itemListFinal, setItemListFinal] = useState([])

  const calculatePageCount = (active_products) => {
    const calculated_page_count = active_products.length / page_items_count;
    const check_if_isInteger = Number.isInteger(calculated_page_count)
    if (check_if_isInteger) {
      setPageCount(calculated_page_count)
      if (calculated_page_count === 1) {
      }
    } else {
      setPageCount(Math.floor(calculated_page_count) + 1)
      if (Math.floor(calculated_page_count) + 1 === 1) {
      }
    }
  }

  useEffect(() => {
    if (filterBy !== "Select status") {
      const active_products = itemsList?.filter(data => {
        if (filterBy === "All") {
          return data
        } else {
          if (data.data.status === filterBy) {
            return data
          }
        }

      }).sort((a, b) => {
        return (
          new Date(
            toIsoString(new Date(b?.data?.dateCreated?.seconds * 1000 + b?.data?.dateCreated?.nanoseconds / 1000000))
          ).getTime() - new Date(toIsoString(new Date(a?.data?.dateCreated?.seconds * 1000 + a?.data?.dateCreated?.nanoseconds / 1000000))).getTime()
        )
      })
      setActivePageNum(1);
      setIsPrevActive(false)
      setIsNextActive(true)
      setRange({
        start: 0,
        end: page_items_count
      })
      setItemListFinal(active_products)
      calculatePageCount(active_products);

      setTimeout(() => {
        setLoading(false)
      }, 1000);
    } else {
      setActivePageNum(1);
      setIsPrevActive(false)
      setIsNextActive(true)
      setRange({
        start: 0,
        end: page_items_count
      })
      setItemListFinal(itemsList)
      calculatePageCount(itemsList);
      setTimeout(() => {
        setLoading(false)
      }, 1000);
    }
  }, [itemsList, filterBy])

  useEffect(() => {
    setLoading(true)
    if (searchBy !== undefined) {

      const active_products = products.filter(data => {
        if (data.product.data.sellerId === searchBy) {
          return data
        } else {
          if (data.data.sku === searchBy) {
            return data
          } else {
            if (data.product.data.titleEn.toLowerCase().includes(searchBy.toLowerCase())) {
              return data
            }
          }
        }

      }).sort((a, b) => {
        return (
          new Date(
            toIsoString(new Date(b?.data?.dateCreated?.seconds * 1000 + b?.data?.dateCreated?.nanoseconds / 1000000))
          ).getTime() - new Date(toIsoString(new Date(a?.data?.dateCreated?.seconds * 1000 + a?.data?.dateCreated?.nanoseconds / 1000000))).getTime()
        )
      })
      // setActivePageNum(1);
      // setIsPrevActive(false)
      // setIsNextActive(true)
      // setRange({
      //   start: 0,
      //   end: page_items_count
      // })
      setItemsList(active_products)
      // calculatePageCount(active_products);

      // setTimeout(() => {
      //   setLoading(false)
      // }, 1000);
    } else {
      const active_products = products.sort((a, b) => {
        return (
          new Date(
            toIsoString(new Date(b?.data?.dateCreated?.seconds * 1000 + b?.data?.dateCreated?.nanoseconds / 1000000))
          ).getTime() - new Date(toIsoString(new Date(a?.data?.dateCreated?.seconds * 1000 + a?.data?.dateCreated?.nanoseconds / 1000000))).getTime()
        )
      })

      // setActivePageNum(1);
      // setIsPrevActive(false)
      // setIsNextActive(true)
      // setRange({
      //   start: 0,
      //   end: page_items_count
      // })
      setItemsList(active_products)
      // calculatePageCount(active_products);
      // setTimeout(() => {
      //   setLoading(false)
      // }, 1000);
    }
  }, [products, searchBy]);



  const handleChangePrevClick = () => {

    if (activePageNum > 1) {
      setIsNextActive(true)
      const updatedPageNum = activePageNum - 1;
      setActivePageNum(updatedPageNum)

      if (updatedPageNum === 1) {
        setIsPrevActive(false)
      } else {
        setIsPrevActive(true)
      }

      setRange({
        start: updatedPageNum * page_items_count - page_items_count,
        end: updatedPageNum * page_items_count
      })
    } else {
      setIsPrevActive(false)
    }
  }

  const handleChangeNextClick = () => {

    if (activePageNum < pageCount) {
      setIsPrevActive(true)
      const updatedPageNum = activePageNum + 1;
      setActivePageNum(updatedPageNum);

      if (updatedPageNum === pageCount) {
        setIsNextActive(false)
      } else {
        setIsNextActive(true)
      }

      setRange({
        start: updatedPageNum * page_items_count - page_items_count,
        end: updatedPageNum * page_items_count
      })

    } else {
      setIsNextActive(false)
    }
  }
  return (
    <div className={styles.market}>
      {
        loading ?
          <div className={styles.loadingContainer}>
            <LoadingIndicator />
          </div>
          : <>
            <div className={styles.table}>
              <div className={styles.row}>
                <div className={styles.col}>Title</div>
                <div className={styles.col}>SKU</div>
                <div className={styles.col}>Category</div>
                <div className={styles.col}>Price</div>
                <div className={styles.col}>Qty</div>
                <div className={styles.col}>Status</div>
              </div>
              {
                itemListFinal
                  ?.map((x, index) => {
                    return (
                      (index >= range.start) && (index < range.end) ?
                        <Row
                          item={x}
                          indexVal={index}
                          up={products.length - index <= 2}
                          value={selectedFilters.includes(x.id)}
                          onChange={() => handleChange(x.id)}
                        /> : <></>
                    )
                  })
              }
            </div>

            {
              pageCount !== 0 && pageCount !== 1 ?
                <div className={styles.foot}>
                  <button
                    style={{
                      opacity: isPrevActive ? 1 : 0.1
                    }}
                    onClick={() => {
                      handleChangePrevClick()
                    }} className={styles.arrow}>
                    <Icon name="arrow-left" size="20" />
                  </button>

                  <button
                    style={{
                      opacity: isNextActive ? 1 : 0.1
                    }}
                    onClick={() => {
                      handleChangeNextClick()
                    }} className={styles.arrow}>
                    <Icon name="arrow-right" size="20" />
                  </button>
                </div>
                : <></>
            }

            {/* <div className={styles.foot}>
              <button className={styles.arrow}>
                <Icon name="arrow-left" size="20" />
              </button>
              <button className={styles.arrow}>
                <Icon name="arrow-right" size="20" />
              </button>
            </div> */}
          </>
      }

    </div>
  );
};

export default Market;
